/**
 * Mixin to set up v-model support for components
 * @param {{}} opts options
 * @param {boolean} opts.deep whether to watch for changes deeply, like when the model is an object
 */
export default function modelMixin({ deep }) {
  return {
    data() {
      return {
        model: this.value || this.schema.value,
      };
    },
    watch: {
      value: {
        deep,
        handler(newValue) {
          this.model = newValue;
        },
      },
      model: {
        deep,
        handler(newValue) {
          this.$emit('input', newValue);
        },
      },
    },
    mounted() {
      // Fire an input event with our initial value
      this.$emit('input', this.model);
    },
  };
}
